var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-card"},[_c('PageTitle',{attrs:{"title":_vm.$t('project.add'),"description":_vm.$t('project.descriptionType')}}),_c('ProjectForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }